import { render } from "./InfosPharmacie.vue?vue&type=template&id=7752433a&ts=true"
import script from "./InfosPharmacie.vue?vue&type=script&lang=ts"
export * from "./InfosPharmacie.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__